import { render, staticRenderFns } from "./sIdentify.vue?vue&type=template&id=5d86e6a6&scoped=true&"
import script from "./sIdentify.vue?vue&type=script&lang=js&"
export * from "./sIdentify.vue?vue&type=script&lang=js&"
import style0 from "./sIdentify.vue?vue&type=style&index=0&id=5d86e6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86e6a6",
  null
  
)

export default component.exports